<div class="reports container-content">
    <div class="page-header">
        <div class="page-title">
            {{
                'portal.clients.pages.client-company-settings.company-report'
                    | translate
            }}
        </div>
    </div>

    <div class="page-nav">
        <div class="pull-left p-t-10">
            <button
                mat-raised-button
                class="in-blue-button pull-left add-new-button"
                (click)="addCompany()"
            >
                {{
                    'portal.clients.pages.client-company-settings.add-company'
                        | translate
                }}
            </button>
        </div>

        <div class="tright navside">
            <span
                class="nbtn export"
                appSecurityTag
                [securityTags]="SECURITY_TAGS.REPORT_EXPORT_EXCEL"
            >
                <button class="navbutton" (click)="excelExport()" mat-button>
                    {{
                        'portal.clients.pages.client-company-settings.export'
                            | translate
                    }}
                </button>
            </span>

            <div class="nbtn search">
                <input
                    id="search"
                    #searchInput
                    (keyup)="applySearch(searchInput)"
                    (keydown)="applySearch(searchInput)"
                    [placeholder]="
                        'portal.clients.pages.client-company-settings.search'
                            | translate
                    "
                />
            </div>
        </div>
    </div>

    <div *ngIf="dataInitialised" class="tablediv">
        <div>
            <app-intable
                [reportTable]="true"
                [enableColumnEdit]="true"
                [enableExport]="false"
                [enableSearch]="false"
                [dataSource]="companiesDataSource"
                [columns]="companyColumns"
                headerRowClasses="thinInTableHeaderRow blueBackground"
                paginatorClasses="pull-right"
                [actions]="companyActions"
                (actionEmitter)="tableAction($event)"
                [searchFilterInput]="searchFilter.asObservable()"
            ></app-intable>
        </div>
    </div>
</div>
